// extracted by mini-css-extract-plugin
export var errorIcon = "_o1-1";
export var nameLogo = "_o1-0";